import { render } from "./VsDropdownItem.vue?vue&type=template&id=0d7ecae2"
import script from "./VsDropdownItem.vue?vue&type=script&lang=js"
export * from "./VsDropdownItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__